module.exports = new __parcel__URL__("leaderboard_logins_button.12385ce6.png").toString();